import type { LoanTypeOption } from './types';
import { LoanTypes } from './types';

/**
 * Selectable loan types (everything except {@link LoanTypes.Unknown}), derived
 * from the {@link LoanTypes} enum so dropdowns and filters share one source of
 * truth. The label is the enum key (LO, LR, LP, SL, OTC).
 */
export const LOAN_TYPE_OPTIONS: LoanTypeOption[] = (
  Object.entries(LoanTypes) as [string, LoanTypes | string][]
)
  .filter(
    (entry): entry is [string, LoanTypes] =>
      typeof entry[1] === 'number' && entry[1] !== LoanTypes.Unknown,
  )
  .map(([label, value]) => ({ label, value }));
